var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow > -1
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(-1);
      }
    }
  }, [_vm.dataToShow == 1 ? _c('div', {
    on: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.addTempFile.apply(null, arguments);
      },
      "dragover": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "my-5 mx-5 md:mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Ajouter un nouveau fichier\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-indigo-100 rounded-lg flex flex-col items-center space-y-3 py-24"
  }, [_c('icon', {
    staticClass: "text-pink-600 w-12 h-12",
    class: {
      'animate-pulse': _vm.loading
    },
    attrs: {
      "name": "file"
    }
  }), _vm._v(" "), !_vm.loading ? _c('div', {
    staticClass: "flex flex-col items-center space-y-3"
  }, [_c('h3', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            Glissez & Déposez\n          ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n            ou\n            "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "upload-file"
    },
    on: {
      "change": _vm.addTempFile
    }
  }), _c('label', {
    staticClass: "underline cursor-pointer",
    attrs: {
      "for": "upload-file"
    }
  }, [_vm._v("sélectionnez")]), _vm._v("\n            votre document\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            " + _vm._s(((_vm.errors || []).file || [])[0]) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n            " + _vm._s(((_vm.errors || []).forbidden || [])[0]) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.loading ? _c('div', [_c('h6', {
    staticClass: "text-gray-600 animate-pulse"
  }, [_vm._v("\n            Fichier en cours d'envoi...\n          ")]), _vm._v(" "), _vm.uploading ? _c('div', {
    staticClass: "w-full mt-2 bg-gray-500 rounded-full"
  }, [_c('div', {
    staticClass: "bg-teal-600 text-md text-center p-0.5 leading-none rounded-full",
    style: `width: ${_vm.uploadProgress}%`
  }, [_vm._v("\n              " + _vm._s(_vm.uploadProgress) + "%\n            ")])]) : _vm._e()]) : _vm._e()], 1)])]) : _vm.dataToShow == 2 ? _c('div', [_c('div', {
    staticClass: "my-5 lg:my-15 2xl:my-20 mx-16 2xl:mx-24"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Ajouter un nouveau fichier\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col justify-center space-y-5 items-center md:flex-row md:justify-start md:space-x-10 md:space-y-0"
  }, [_vm.constants.FILE_TYPES.img.includes(_vm.filetype.toLowerCase()) ? _c('img', {
    staticClass: "object-cover w-64 h-64 2xl:w-80 2xl:h-80 rounded-md border border-indigo-300",
    attrs: {
      "src": '/' + _vm.fileTemp.path
    }
  }) : _vm.constants.FILE_TYPES.pdf.includes(_vm.filetype.toLowerCase()) ? _c('embed', {
    staticClass: "w-64 h-64 2xl:w-80 2xl:h-80 rounded-md border border-indigo-300",
    attrs: {
      "src": '/' + _vm.fileTemp.path + '#toolbar=0&navpanes=0'
    }
  }) : _vm.constants.FILE_TYPES.doc.includes(_vm.filetype.toLowerCase()) ? _c('div', {
    staticClass: "flex items-center justify-center w-64 h-64 2xl:w-80 2xl:h-80 rounded-md bg-gray-200 border border-indigo-300"
  }, [_c('icon', {
    staticClass: "text-blue-600 transform scale-150",
    attrs: {
      "name": "file"
    }
  })], 1) : _vm.constants.FILE_TYPES.xls.includes(_vm.filetype.toLowerCase()) ? _c('div', {
    staticClass: "flex items-center justify-center w-64 h-64 2xl:w-80 2xl:h-80 rounded-md bg-gray-200 border border-indigo-300"
  }, [_c('icon', {
    staticClass: "text-green-600 transform scale-150",
    attrs: {
      "name": "file"
    }
  })], 1) : _c('div', {
    staticClass: "flex items-center justify-center w-64 h-64 2xl:w-80 2xl:h-80 rounded-md bg-gray-200 border border-indigo-300"
  }, [_c('icon', {
    staticClass: "text-gray-900 transform scale-150",
    attrs: {
      "name": "file"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-4 items-center md:gap-10 w-full"
  }, [_c('div', {
    staticClass: "col-span-1"
  }, [_vm._v("\n            Nom\n          ")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "nom",
      "value": _vm.filename,
      "maxlength": 40,
      "error": true
    },
    on: {
      "input": function (newValue) {
        _vm.filename = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full h-10 md:hidden"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-1"
  }, [_vm._v("\n            Emplacement\n          ")]), _vm._v(" "), _c('search-bar', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "searchFolder",
      "has-border": true,
      "icon": "chevron-down",
      "icon-color": "text-pink-600",
      "placeholder": "Définir l'emplacement",
      "value": _vm.searchFolder,
      "has-suggestion": true
    },
    on: {
      "input": function (newValue) {
        _vm.searchFolder = newValue;
      },
      "displaySuggestionsList": function (state) {
        _vm.displaySuggestionsFoldersList(state);
      }
    },
    scopedSlots: _vm._u([_vm.isFoldersListDisplayed ? {
      key: "suggestionsList",
      fn: function () {
        return [_c('div', {
          staticClass: "h-20 border-b border-indigo-600 grid grid-cols-12 gap-x-3 items-center px-6"
        }, [_c('div', {
          staticClass: "col-span-2 cursor-pointer"
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.currentFolderInFolderSelection != null,
            expression: "currentFolderInFolderSelection != null"
          }],
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.returnBack.apply(null, arguments);
            }
          }
        }, [_c('icon', {
          staticClass: "text-indigo-600 h-5 w-5",
          attrs: {
            "name": "arrow-circle-left"
          }
        })], 1)]), _vm._v(" "), _c('h5', {
          staticClass: "col-span-10 text-left"
        }, [_vm._v("\n                  Dossiers\n                ")])]), _vm._v(" "), _vm.currentFolderInFolderSelection == null ? _c('div', {
          staticClass: "h-20 cursor-default grid grid-cols-12 items-center gap-x-3 px-6 bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.selectFolder({
                id: null,
                name: 'Dépôt de documents'
              });
            }
          }
        }, [_c('icon', {
          staticClass: "col-span-2 h-6 w-7 text-gray-600",
          attrs: {
            "name": "folder"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-10 flex items-center space-x-3 ml-2 md:ml-0"
        }, [_c('p', {
          staticClass: "text-lg"
        }, [_vm._v("\n                    Mon dépôt de documents\n                  ")])])], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.foldersFilter.filter(function (f) {
          return f.folder_id == _vm.currentFolderInFolderSelection;
        }), function (folder, kf) {
          return _c('div', {
            key: kf,
            staticClass: "h-20 cursor-default grid grid-cols-12 items-center gap-x-3 px-6 bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.selectFolder(folder);
              }
            }
          }, [_c('icon', {
            staticClass: "col-span-2 h-6 w-7",
            class: {
              'text-indigo-600': folder.color == 'indigo',
              'text-teal-600': folder.color == 'teal',
              'text-orange-600': folder.color == 'orange',
              'text-pink-600': folder.color == 'pink',
              'text-gray-600': folder.color == 'gray'
            },
            attrs: {
              "name": "folder"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "col-span-10 flex items-center space-x-3 ml-2 md:ml-0"
          }, [_c('p', {
            staticClass: "text-lg"
          }, [_vm._v("\n                    " + _vm._s(folder.name) + "\n                  ")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.folders.filter(function (f) {
                return f.folder_id == folder.id;
              }).length > 0,
              expression: "\n                      folders.filter((f) => f.folder_id == folder.id).length >\n                        0\n                    "
            }],
            staticClass: "text-base font-light italic text-gray-600"
          }, [_vm._v("\n                    " + _vm._s(_vm.folders.filter(function (f) {
            return f.folder_id == folder.id;
          }).length) + "\n                    Dossier" + _vm._s(_vm.folders.filter(function (f) {
            return f.folder_id == folder.id;
          }).length > 1 ? 's' : '') + "\n                  ")]), _vm._v(" "), _c('div', {
            staticClass: "flex-grow"
          }), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.folders.filter(function (f) {
                return f.folder_id == folder.id;
              }).length,
              expression: "\n                      folders.filter((f) => f.folder_id == folder.id).length\n                    "
            }],
            staticClass: "cursor-pointer",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                _vm.currentFolderInFolderSelection = folder.id;
              }
            }
          }, [_c('icon', {
            staticClass: "text-pink-600 transform duration-300 hover:scale-125",
            attrs: {
              "name": "chevron-right"
            }
          })], 1)])], 1);
        })];
      },
      proxy: true
    } : null], null, true)
  }), _vm._v(" "), false ? _c('div', {
    staticClass: "col-span-full grid grid-cols-4 items-center gap-10 w-full"
  }, [_c('div', {
    staticClass: "col-span-1"
  }, [_vm._v("\n              Partage\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "lg:col-span-3 flex justify-center space-x-5 mt-10"
  }, [_c('search-bar', {
    attrs: {
      "name": "share",
      "libelle": "Partager",
      "value": _vm.search,
      "placeholder": "Ajouter des personnes ou des groupes",
      "big": false,
      "inherits": false,
      "has-border": true,
      "has-suggestion": true
    },
    on: {
      "input": function (newValue) {
        _vm.search = newValue;
      },
      "displaySuggestionsList": function (state) {
        _vm.displaySuggestionsList(state);
      }
    },
    scopedSlots: _vm._u([_vm.isSuggestionsListDisplayed ? {
      key: "suggestionsList",
      fn: function () {
        return _vm._l(_vm.membersFilterSearch, function (member, memberIndex) {
          return _c('div', {
            key: memberIndex,
            staticClass: "h-20 cursor-default grid grid-cols-12 items-center bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.selectMember(member);
              }
            }
          }, [_c('div', {
            staticClass: "col-span-2 place-self-center"
          }, [_c('div', {
            staticClass: "h-full w-full px-2"
          }, [_c('ProfilePicture', {
            attrs: {
              "size": "max-w-12 w-12 h-12",
              "other-object": member
            }
          })], 1)]), _vm._v(" "), member.username ? _c('div', {
            staticClass: "grid grid-cols-12 gap-x-4 col-span-10 text-left ml-4"
          }, [_c('div', {
            staticClass: "grid-cols-12 gap-x-4",
            class: {
              'col-span-6': !_vm.memberHasAccessToDepotDoc(member),
              'col-span-full': _vm.memberHasAccessToDepotDoc(member)
            }
          }, [_c('div', {
            staticClass: "text-lg font-normal col-span-full truncate"
          }, [_c('span', {
            staticClass: "userFirstNameDiv"
          }, [_vm._v(_vm._s(member.firstname + ' '))]), _vm._v(" "), _c('span', {
            staticClass: "uppercase userLastNameDiv"
          }, [_vm._v(_vm._s(member.lastname))])]), _vm._v(" "), _c('div', {
            staticClass: "col-span-full text-sm text-gray-600"
          }, [_vm._v("\n                          " + _vm._s(_vm.mainRole(member).display_name) + "\n                        ")])]), _vm._v(" "), _vm.memberIsBeneficiary(member) && !_vm.memberHasAccessToDepotDoc(member) ? _c('span', {
            staticClass: "col-span-6 my-auto text-pink-600 text-2sm italic font-light"
          }, [_vm._v("\n                        Cet utilisateur n'a pas accès au module dépôt de\n                        documents\n                      ")]) : !_vm.memberHasAccessToDepotDoc(member) ? _c('span', {
            staticClass: "col-span-6 my-auto text-pink-600 text-2sm italic font-light"
          }, [_vm._v("\n                        Le rôle «" + _vm._s(_vm.mainRole(member).display_name) + "» n'a pas\n                        accès au module dépôt de documents\n                      ")]) : _vm._e()]) : _c('div', {
            staticClass: "grid grid-cols-12 gap-x-4 col-span-10 text-left ml-4"
          }, [_c('div', {
            staticClass: "grid-cols-12 gap-x-4 col-span-6",
            class: {
              'col-span-6': !_vm.roleHasAccessToDepotDoc(member),
              'col-span-full': _vm.roleHasAccessToDepotDoc(member)
            }
          }, [_c('div', {
            staticClass: "text-lg font-normal col-span-full truncate roleNameDiv"
          }, [_vm._v("\n                          " + _vm._s(member.display_name) + "\n                        ")]), _vm._v(" "), member.company_id == null ? _c('div', {
            staticClass: "col-span-full text-sm text-gray-600"
          }, [_vm._v("\n                          Role par défaut\n                        ")]) : _vm._e()]), _vm._v(" "), !_vm.roleHasAccessToDepotDoc(member) ? _c('span', {
            staticClass: "col-span-6 my-auto text-pink-600 text-2sm italic font-light"
          }, [_vm._v("\n                        Ce rôle n'a pas accès au module dépôt de documents\n                      ")]) : _vm._e()])]);
        });
      },
      proxy: true
    } : null], null, true)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "lg:col-span-3 flex justify-center space-x-5"
  }, [_vm.selectedMembersFlat.length > 0 ? _c('div', {
    staticClass: "flex flex-row flex-wrap items-center justify-start h-full gap-2 max-h-36 p-1 rounded-md border-indigo-600 border w-full border-opacity-50 overflow-y-scroll"
  }, _vm._l(_vm.selectedMembersFlat, function (selected, selectedIndex) {
    return _c('div', {
      key: selectedIndex
    }, [selected.username ? _c('tag', {
      attrs: {
        "libelle": selected.firstname + ' ' + selected.lastname.toUpperCase(),
        "theme-color": _vm.roleColor(selected),
        "is-closeable": true
      },
      on: {
        "close": function ($event) {
          return _vm.deselectMember(true, selectedIndex);
        }
      }
    }) : _c('tag', {
      attrs: {
        "libelle": selected.display_name,
        "theme-color": _vm.roleColor(selected),
        "is-closeable": true
      },
      on: {
        "close": function ($event) {
          return _vm.deselectMember(false, selectedIndex);
        }
      }
    })], 1);
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "lg:col-span-3 grid grid-cols-12 gap-x-4 items-end"
  }, [_vm.selectedMembersFlat.length > 0 ? _c('div', {
    staticClass: "col-span-9"
  }, [_c('input-select', {
    attrs: {
      "libelle": 'Droits d\'accès',
      "name": "access_rights",
      "value": "Lecteur",
      "datas": [{
        value: 'Administrateur'
      }, {
        value: 'Editeur'
      }, {
        value: 'Lecteur'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.accessRights = newValue;
      }
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center mt-5"
  }, [_c('div', {
    staticClass: "text-red-500 text-sm my-5"
  }, [_vm._v("\n          " + _vm._s(((_vm.errors || []).forbidden || [])[0]) + "\n        ")]), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Ajouter",
      "uppercase": true,
      "type-shadow": "shadow-pink",
      "icon": "arrow-right_1",
      "right": true
    },
    on: {
      "clickAction": _vm.addFile
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }